export const SuccessIcon = () => (
	<svg width="21" height="20" viewBox="0 0 21 20" fill="none">
		<g clipPath="url(#clip0_20695_9613)">
			<path
				d="M19.7669 5L10.9358 13.3333L9.27054 11.762M1.43359 9.08497L5.93576 13.3333L14.7669 5"
				stroke="#72DBAA"
				strokeWidth="1.5"
			/>
		</g>
		<defs>
			<clipPath id="clip0_20695_9613">
				<rect width="20" height="20" fill="white" transform="translate(0.599609)" />
			</clipPath>
		</defs>
	</svg>
);
